// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"185f5333ea5c217bff2d","655":"f1f4c5582b06c4ac3d59"}[chunkId] + ".js";
};